import DialogCategoryProductOptionProduct from './DialogCategoryProductOptionProduct';

export default DialogCategoryProductOptionProduct;
